import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
    <Toaster 
      position="bottom-center"
      toastOptions={{
        style: {
          background: '#333',
          color: '#fff',
          borderRadius: '12px',
        },
      }}
    />
  </React.StrictMode>
);
